export const ASSOCIATE_CONFIG_ENTITY_TYPE = {
  CATEGORY: 'category',
  PRODUCT: 'product',
};

export const CONFIG_UI_TYPE = {
  INPUT: 'INPUT',
  RADIO: 'RADIO',
  DROPDOWN: 'DROPDOWN',
};

export const CONFIG_DATA_TYPE = {
  STRING: 'STRING',
  NUMBER: 'NUMBER',
  BOOL: 'BOOL',
};

export const CONFIG_DATA_OPTION = {
  SINGLE_VALUE: 'SINGLE_VALUE',
  MULTI_VALUE: 'MULTI_VALUE',
};

export const CONFIG_VALUE_TYPE = {
  SINGLE: 'SINGLE',
  OBJECT: 'OBJECT',
};

export const CONFIG_VALUE_TYPE_OPTIONS = [
  { label: 'Single Value', value: CONFIG_VALUE_TYPE.SINGLE },
  { label: 'Value Slab', value: CONFIG_VALUE_TYPE.OBJECT },
];

export const CONFIG_USER_MODIFIABLE_OPTIONS = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
];

export const CNF_UI_COMPONENT = {
  UI_COMP_PROD_DETAIL: 'UI_COMP_PROD_DETAIL',
  UI_COMP_DETAIL: 'UI_COMP_DETAIL',
};

export const PRODUCT_CONFIGURATION_TAB = {
  GENERAL: 'general',
  CONFIGS: 'configs',
  FEATURES: 'features',
};

export const PRODUCT_CONFIGURATION_TAB_OPTIONS = [
  { key: PRODUCT_CONFIGURATION_TAB.GENERAL, label: 'General' },
  { key: PRODUCT_CONFIGURATION_TAB.CONFIGS, label: 'Configs' },
  { key: PRODUCT_CONFIGURATION_TAB.FEATURES, label: 'Features' },
];

export const BREADCRUMB_ENTITY_TYPE = {
  CATEGORY: 'category',
  PRODUCT: 'product',
};

export const BREADCRUMB_PRODUCT_ID_PREFIX = 'UPROD';

export const PRODUCT_CATEGORY_ROOT_PARENT = {
  product_category_id: 'ROOT',
  category_name: 'ROOT',
};

export const CONFIG_CATEGORY_FETCH_PARAMS = {
  page: 1,
  rows: 1000,
};

export const PRODUCT_CONFIG_CATEGORY_CODE = {
  PRODUCT_CONFIG: 'PRODUCT_CONFIG',
};

// Max feature chips shown on a collapsed feature category card (category context).
export const FEATURE_CHIPS_VISIBLE_COUNT = 3;

export const CONFIG_VALUE_SOURCE = {
  INHERITED: 'inherited',
  OWN: 'own',
  CURRENT: 'current',
};

export const PRODUCT_CONFIG_VALUE_SOURCE_META = {
  [CONFIG_VALUE_SOURCE.INHERITED]: {
    label: 'Inherited',
    description: 'Value from a parent category or product',
    color: '#faad14',
  },
  [CONFIG_VALUE_SOURCE.OWN]: {
    label: 'Own',
    description: 'Set directly for this context',
    color: '#52c41a',
  },
  [CONFIG_VALUE_SOURCE.CURRENT]: {
    label: 'Own + Inherited',
    description: 'Set here; parent context also has a value',
    color: '#175cd3',
  },
};

export const PRODUCT_CONFIG_VALUE_SOURCE_LEGEND = [
  {
    source: CONFIG_VALUE_SOURCE.INHERITED,
    ...PRODUCT_CONFIG_VALUE_SOURCE_META[CONFIG_VALUE_SOURCE.INHERITED],
  },
  {
    source: CONFIG_VALUE_SOURCE.OWN,
    ...PRODUCT_CONFIG_VALUE_SOURCE_META[CONFIG_VALUE_SOURCE.OWN],
  },
  {
    source: CONFIG_VALUE_SOURCE.CURRENT,
    ...PRODUCT_CONFIG_VALUE_SOURCE_META[CONFIG_VALUE_SOURCE.CURRENT],
  },
];

export const PRODUCT_CONFIG_CONFIRM_MODAL_CLASS = 'product-config-confirm-modal';
